import { formatEmail, isValidEmailFormat } from '@shared';
import { useEffect, useState } from 'react';
import { EmailRecipientInput, Tag, ValidationResult } from './EmailRecipientInput';

interface EmailTagInputProps {
  onChange?: (emails: Tag[]) => void;
  initialEmails?: Tag[];
  maxEmails?: number;
  clearWarnings?: boolean;
  label?: string;
}

export function EmailTagInput({
  onChange,
  initialEmails = [],
  maxEmails,
  clearWarnings = false,
  label,
}: EmailTagInputProps) {
  const [emails, setEmails] = useState<Tag[]>(initialEmails);

  useEffect(() => {
    setEmails(initialEmails);
  }, [initialEmails]);

  const validateEmail = (email: string): ValidationResult => {
    if (!isValidEmailFormat(email)) {
      return {
        isValid: false,
        error: 'Invalid email format',
      };
    }
    return {
      isValid: true,
      error: '',
    };
  };

  const handleEmailsChange = (newEmails: Tag[]): void => {
    setEmails(newEmails);
    onChange?.(newEmails);
  };

  return (
    <div data-testid="bulk-invite-email-tag-input">
      <EmailRecipientInput
        recipients={emails}
        onRecipientsChange={handleEmailsChange}
        validateRecipient={validateEmail}
        formatRecipient={formatEmail}
        maxRecipients={maxEmails}
        label={label}
      />
    </div>
  );
}
